import {
	promoGeneralSX,
	promoIconSX,
	separatorSx,
	typoSX,
} from '@/components/blocks/PromotionCard/styles/PromoIconStyles';
import {
	PRODUCT_CARD_PROMO_ICONS_IMG_URL,
	PROMOTION_TYPES,
} from '@/data/constants/promoIconConstants';
import { useLocalization } from '@/data/Localization';
import { setClassName } from '@/data/utils/usePromoIcons/promoLists';
import { Box, CardMedia, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CDN_BASE_URL } from 'shared/custom/constants/commonConstants';

export const Remate = () => {
	const { FinalChance, SavingOnLastUnits, GreatSalePromo } = useLocalization('PromoIconsTxt');
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const ICON_URL = `${CDN_BASE_URL}/${PRODUCT_CARD_PROMO_ICONS_IMG_URL.PROMOICON_GR}`;
	return (
		<Box>
			<Divider sx={separatorSx} />
			<Box>
				<Box sx={promoGeneralSX.promoiconContainer} id={PROMOTION_TYPES.PROMOICON_GR}>
					<CardMedia
						image={ICON_URL}
						sx={promoIconSX.remate}
						title={GreatSalePromo.t()}
						component="img"
						className={setClassName(PROMOTION_TYPES.PROMOICON_GR)}
					/>
					<Box>
						<Typography variant="body1" component={isMobile ? 'p' : 'span'} sx={typoSX.firstRow}>
							{FinalChance.t()}{' '}
						</Typography>
						<Typography variant="body1" component={'span'} sx={typoSX.secondRow}>
							{SavingOnLastUnits.t()}
						</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
